import { BORDER_RADIUS_LARGE } from '../constants';

export default {
  styleOverrides: {
    root: {
      borderRadius: BORDER_RADIUS_LARGE,
    },
  },
};
